import { createFileRoute } from '@tanstack/react-router'

import { PrivacyPolicy } from '~/boundedContext/compliance/pages/privacy-policy'

export const Route = createFileRoute('/privacy-policy')({
  component: PrivacyPolicy,
})
